<template>
  <VTooltip v-model:shown="shown"
            placement="right"
            :triggers="['click']"
            :distance="10">
    <template #popper>
      <span class="contextual-help-content" ref="popper">
        {{ text }}
      </span>
    </template>

    <span class="help-trigger" style="cursor: pointer;" data-test-element="help-trigger" ref="trigger">
      <i class="material-icons themed-icon">help_outline</i>
    </span>
  </VTooltip>
</template>

<script>
  export default {
    name: 'popper-help-component',
    props: ['text'],
    data() {
      return { shown: false };
    },
    mounted() {
      this._onDocClick = (evt) => {
        const t = evt.target;
        const triggerEl = this.$refs.trigger;
        const popperEl = this.$refs.popper;
        if (triggerEl && popperEl && !triggerEl.contains(t) && !popperEl.contains(t)) {
          this.shown = false;
        }
      };
      document.addEventListener('click', this._onDocClick, true);
    },
    unmounted() {
      document.removeEventListener('click', this._onDocClick, true);
      this._onDocClick = null;
    }
  }
</script>

<style>
</style>